import Provider                                                  from '@/provider/Provider';
import Header                                                    from '@/components/common/Header';
import AvisoRpg                                                  from '@/components/common/AvisoRpg';

import '../assets/css/index.css';

export default function MyApp({ Component, pageProps }) {
  return (
    <>
      <Provider>
        <Header />
        <Component {...pageProps} />
        <AvisoRpg />
      </Provider>
    </>
  );
}
